<template>
  <v-app app>
    <v-main class="asupload-container">
      <db-as-header />
      <div class="tab-container">
        <vue-waterfall-easy
          :imgWidth="imgWidth"
          ref="waterfall"
          :imgsArr="imgsArr"
          @click="onImgItemClick"
          @scrollReachBottom="getNextAssets"
        >
          <div slot="waterfall-over">
            <div v-if="imgsArr.length > 0">没有更多图片啦</div>
          </div>
          <div class="img-info" slot-scope="props">
            <div class="float-gif" v-if="props.value.isGif">GIF</div>
          </div>
        </vue-waterfall-easy>

        <db-as-asset-dialog
          :activeAssetImg="activeAssetImg"
          :showActiveAssetImg="showActiveAssetImg"
          v-on:update="closePreview"
        />
      </div>
    </v-main>
    <db-as-footer></db-as-footer>
  </v-app>
</template>

<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import DbAsFooter from './components/DbAsFooter'
import DbAsAssetDialog from './components/DbAsAssetDialog'
import { getAssetList, getAssetInfo, deleteAsset } from '../util/api'
import DbAsHeader from './components/DbAsHeader'
import { supportAnimImg } from '../util/tool'
export default {
  name: 'DbAsUpload',
  data: function() {
    let atype = 8
    switch (this.$route.params.type) {
      case 'dbas': {
        atype = 8
        break
      }
      case 'nav': {
        atype = 11
        break
      }
    }
    return {
      activeBottomBar: this.$route.name === 'DbAsMy' ? 'my' : 'ground',
      imgsArr: [],
      imgWidth: (document.body.clientWidth - 40) / 2,

      offset: 0,
      limit: this.$route.params.type === 'nav' ? 20 : 10,

      activeAssetImg: {},
      activeAssetImgIndex: -1,
      showActiveAssetImg: false,
      atype
    }
  },
  components: {
    vueWaterfallEasy,
    dbAsFooter: DbAsFooter,
    dbAsAssetDialog: DbAsAssetDialog,
    dbAsHeader: DbAsHeader
  },
  mounted() {
    this.initAssetData()
    this.initActiveAssetImg()
  },
  methods: {
    closePreview() {
      this.showActiveAssetImg = false
      this.$router.replace({
        path: `/imgu/${this.$route.params.type}/${this.activeBottomBar}/0`
      })
    },
    async initActiveAssetImg() {
      const { id } = this.$route.params
      if (id <= 0) {
        return
      }
      try {
        const assetInfo = await getAssetInfo(id)
        this.activeAssetImg = {
          ...assetInfo,
          src: `${assetInfo.cdnUrl}/${assetInfo.src}`,
          href: ''
        }
        this.showActiveAssetImg = true
      } catch (e) {
        console.log(e)
        // nothings
      }
    },
    onImgItemClick(event, { index, value }) {
      event.preventDefault()
      this.activeAssetImg = {
        ...value,
        src: value.src.replace('style/wdbweb_jpg', 'style/wdbweb')
      }
      this.activeAssetImgIndex = index
      // 只有当点击到图片时才进行操作
      if (event.target.tagName.toLowerCase() == 'img') {
        this.showActiveAssetImg = true
        this.$router.replace(
          `/imgu/${this.$route.params.type}/${this.activeBottomBar}/${value.code}`
        )
        return
      }
    },
    onCloseActiveAsset() {
      this.showActiveAssetImg = false
      this.$router.replace(
        `/imgu/${this.$route.params.type}/${this.activeBottomBar}/0`
      )
    },
    async initAssetData() {
      let listDataRes = []
      this.offset = 0
      listDataRes = await this.getData(this.offset, this.limit, -1)

      const assets = listDataRes.assets.map(this.assetToImgData)
      this.imgsArr = this.imgsArr.concat(assets)
    },
    async getData(offset, limit, uid) {
      try {
        const res = await getAssetList({
          offset,
          limit,
          atype: this.atype,
          uid
        })
        res.assets = res.assets.map(item => ({
          ...item,
          src: item.src.replace(/style\/wdbweb/, 'style/wdbweb_jpg'),
          isGif:
            /\.gif/.test(item.src) && supportAnimImg(this.$route.params.type)
        }))
        return res
      } catch (e) {
        return {
          asset: []
        }
      }
    },
    assetToImgData(asset) {
      return {
        ...asset,
        src: `${asset.cdnUrl}${asset.src}`,
        href: '/'
      }
    },
    async getNextAssets() {
      let listDataRes = []
      this.offset += this.limit
      listDataRes = await this.getData(this.offset, this.limit, -1)

      const serverAssets = listDataRes.assets.map(this.assetToImgData)
      if (serverAssets.length < 1) {
        this.$refs.waterfall.waterfallOver()
      } else {
        this.imgsArr = this.imgsArr.concat(serverAssets)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.float-gif {
  right: 10px;
  top: 10px;
  position: absolute;
  color: white;
  opacity: 0.6;
  font-size: 13px;
  padding: 2px 5px;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.asupload-container {
  .v-main__wrap {
    display: flex;
    flex-direction: column;
  }
  .v-toolbar {
    flex-grow: 0;
  }
  .img-box {
    img {
      background-color: black;
    }
    .alink {
      text-decoration: none !important;
    }
  }
}
</style>
<style scoped lang="scss">
.tab-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.tab-content {
  height: 100%;
}
.float-btn {
  bottom: 10px !important;
}
</style>
